import { render, staticRenderFns } from "./card-address.vue?vue&type=template&id=374689b3&"
import script from "./card-address.vue?vue&type=script&lang=js&"
export * from "./card-address.vue?vue&type=script&lang=js&"
import style0 from "./card-address.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports